import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import {
  IDataResponseOrderSimulate,
  IDataOrderSimulate,
  ICheckoutResponse,
  IPayloadOrderSimulate,
  ISalesParams,
  IOrderSimulateState
} from '../../store/ducks/order-simulate-checkout-mvp/types';
import { IItemSaleInfo } from '../../store/ducks/long-steel-shopping-cart/types';
import { ELocalStorageKey, ILocalStorageObj } from '../EGerdauService/types';
import { CHECKOUT_ORDERS_INITIAL_STATE } from '../../store/ducks/order-simulate-checkout-mvp';

export class CheckoutServiceMvp extends EGerdauService {
  private localStorageKey = ELocalStorageKey.CHECKOUT;
  constructor() {
    super();
  }

  /**
   * Gera simulação de ordem
   * @param bodyRequest request object data
   * @returns res
   */
  async generateOrderSimulate(params: IDataOrderSimulate) {
    // const dispatch = useDispatch();
    const headers = new EGerdauService().getHeaders();
    const requestURL = ECustomerAuthorizationEndpoints.ORDER_SIMULATE;
    const payload: IPayloadOrderSimulate = this.setPayloadOrderSimulate(params);

    try {
      const response = await customersAuthorizationApi.post(
        requestURL,
        payload,
        {
          headers
        }
      );
      const typedResponse = response.data as IDataResponseOrderSimulate;

      const result: ICheckoutResponse = {
        orders: typedResponse.orders,
        o_price_sap_totals: typedResponse.o_price_sap_totals,
        cartId: params.cartNumber,
        cartCreatedIn: params.createdAt,
        cartUpdatedIn: params.updatedAt
      };
      return result;
    } catch (error) {
      return new Error('Serviço indisponível temporariamente');
    }
  }

  /**
   * Get cart data
   * @param cartId cart identifier
   * @returns cart data
   */
  async deleteAllCartItems(cartId: string) {
    const headers = new EGerdauService().getHeaders();

    const requestURL = `${ECustomerAuthorizationEndpoints.CARTS}/${cartId}/items`;
    const response = await customersAuthorizationApi.delete(requestURL, {
      headers
    });
    return response;
  }

  async sendOrder(salesParams: ISalesParams): Promise<string[]> {
    try {
      const headers = super.getHeaders();

      const itemsSaleInfo: IItemSaleInfo[] = salesParams.data.map((item) => {
        delete item.minimumQuantity;
        delete item.multipleQuantity;
        return item;
      });

      await customersAuthorizationApi.post(
        `${ECustomerAuthorizationEndpoints.SEND_ORDER_V2}?customer=${salesParams.emitterId}`,
        {
          items: itemsSaleInfo,
          soldTo: salesParams.emitterId,
          shipTo: salesParams.receiverId,
          purchaseNumber: salesParams.customerOrder,
          cartNumber: salesParams.cartNumber
        },
        { headers }
      );

      const createdOrders: string[] = [salesParams.customerOrder ?? ''];

      return createdOrders;
    } catch (error) {
      throw new Error(
        'Seu pedido não pôde ser enviado. Entre em contato com o seu vendedor.'
      );
    }
  }

  /**
   * Get cart items data
   * @param cartId cart identifier
   * @returns cart items data
   */
  async getItemsFromCart(cartId: string) {
    const headers = new EGerdauService().getHeaders();

    const requestURL = `${ECustomerAuthorizationEndpoints.CARTS}/${cartId}/items`;
    const response = await customersAuthorizationApi.get(requestURL, {
      headers
    });
    return response.data;
  }

  updateCheckoutStateLocalStorage(checkoutState: IOrderSimulateState): void {
    super.setLocalStorage(this.localStorageKey, checkoutState);
  }

  getCheckoutFromLocalStorage(): IOrderSimulateState {
    const localStorageData = super.getLocalStorage(this.localStorageKey);

    return localStorageData && this.canReturnLocalStorageData(localStorageData)
      ? localStorageData.obj
      : CHECKOUT_ORDERS_INITIAL_STATE;
  }

  private canReturnLocalStorageData(
    localStorageData: ILocalStorageObj
  ): boolean {
    const now = new Date();
    return now.getTime() - localStorageData.dateTime <= 3600000; // 1h
  }

  private setPayloadOrderSimulate(
    params: IDataOrderSimulate
  ): IPayloadOrderSimulate {
    return {
      cartNumber: params.cartNumber,
      purchaseNumber: params.purchaseNumber,
      shipTo: params.shipTo,
      soldTo: params.soldTo,
      items: params.items.map((item) => ({
        activitySector: item.activitySector,
        benefit: item.benefit,
        consumptionOrder: item.consumptionOrder,
        distrChannel: item.distrChannel,
        industrialType: item.industrialType,
        item_id_gerdau: item.item_id_gerdau,
        material: item.material,
        plant: item.plant,
        price_agreement_date_gerdau: item.price_agreement_date_gerdau,
        quantity: item.quantity,
        requiredDate: item.requiredDate,
        salesGroup: item.salesGroup,
        salesOffice: item.salesOffice,
        salesOrg: item.salesOrg,
        term: item.term,
        unityMeasure: item.unityMeasure
      }))
    };
  }
}
